module.exports = __webpack_public_path__ + "img/M2_MS_34.3ed19ea1.png";